import React, { useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Button
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.tsx';
import ThuisverpleegLogo from '../components/ThuisverpleegLogo.tsx';
import Sidebar from '../components/Sidebar.tsx';


const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    document.title = 'Thuisverpleging Portaal - Professionele Zorgverlening';
  }, []);

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Sidebar - only show if authenticated */}
      {isAuthenticated && <Sidebar open={true} onClose={() => {}} />}

      {/* Main Content */}
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          ml: isAuthenticated ? 0 : 0,
          minHeight: '100vh'
        }}
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Box
            sx={{
              minHeight: '80vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {/* Header */}
            <Paper 
              sx={{ 
                p: 4, 
                textAlign: 'center',
                background: 'linear-gradient(45deg, #4aa8b4 30%, #5cb8c4 90%)',
                color: 'white',
                mb: 4
              }}
            >
              <ThuisverpleegLogo width={80} height={80} />
              <Typography variant="h3" component="h1" gutterBottom sx={{ mt: 2 }}>
                Thuisverpleging Portaal
              </Typography>
              <Typography variant="h6">
                {isAuthenticated
                  ? user?.first_name
                    ? `Welkom terug, ${user.first_name}!`
                    : 'Welkom terug'
                  : 'Welkom bij het professionele platform voor thuiszorg'
                }
              </Typography>
            </Paper>

            {/* Content based on authentication status */}
            {!isAuthenticated && (
              <Paper sx={{ p: 3, textAlign: 'center', maxWidth: 600, mb: 3 }}>
                <Typography variant="h5" gutterBottom color="text.secondary">
                  Homepage
                </Typography>
                {/* Login button */}
                <Button
                  variant="contained"
                  size="large"
                  onClick={handleLoginClick}
                  sx={{ mt: 2 }}
                >
                  Inloggen voor Zorgverleners
                </Button>
              </Paper>
            )}


          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default HomePage;
